import Rails from "@rails/ujs"
import { Controller } from "stimulus";

function validate_email(email) {
  var regex = /^([a-zA-Z0-9._+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
}

function skipObjectIfExists(optionObject, value) {
  return $(optionObject).find('option[value=' + value + ']').length > 0;
}

function validate_phone(phone) {
  return (phone.replace(/[_-]/gi, '').length == 10);
}

function correctDateFormat(date) {
  return date.toLocaleDateString();
  return moment(date).format('MM/DD/YYYY h:mm:ss A');
}

function getDateInterval(from, to) {
  var res = '';
  if (from != null) {
    res += " from " + correctDateFormat(from);
  }

  if (to != null) {
    res += " until " + correctDateFormat(to);
  }
  return res;
}

function errorElementFor(element) {
  return document.querySelector(`[data-error-for="${element.id}"]`);
}

function setFieldMessage(element, message, options = {}) {
  const config = { invalid: true, level: 'error', ...options };
  const errorElement = errorElementFor(element);
  if (!errorElement) return;

  errorElement.innerHTML = message || '';
  errorElement.classList.toggle('d-none', !message);
  errorElement.classList.remove('invalid-feedback-custom', 'text-info');
  errorElement.classList.add(config.level === 'info' ? 'text-info' : 'invalid-feedback-custom');

  $(element).closest('.form-group').toggleClass('has-error', config.invalid && !!message);

  if (config.invalid && message) {
    element.setAttribute('aria-invalid', 'true');
  } else {
    element.removeAttribute('aria-invalid');
  }
}

function clearFieldMessage(element) {
  setFieldMessage(element, '', { invalid: false });
}

function toggleAssociatedCopy(element, visible) {
  const describedBy = (element.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
  describedBy.forEach((id) => {
    const copy = document.getElementById(id);
    if (copy) copy.hidden = !visible;
  });
}

export default class extends Controller {
  static targets = ["school", "instructor", "semester", "course", "accessCode", "username",
                    "password", "confirmPassword", "firstName", "lastName", "email", "confirmEmail", "phone", "terms", "submit",
                    "verificationContainer", "sendCodeButton", "sendCodeResult", "emailCode", "status"];

  initialize() {
  }

  announceStatus(message) {
    if (!this.hasStatusTarget || !message) return;

    this.statusTarget.textContent = '';
    window.requestAnimationFrame(() => {
      this.statusTarget.textContent = message;
    });
  }

  announceIfEnabled(target, previousState, message) {
    if (previousState && !target.disabled) {
      this.announceStatus(message);
    }
  }

  setDisabled(target, disabled, messageWhenEnabled = null) {
    const previousState = target.disabled;
    target.disabled = disabled;
    this.announceIfEnabled(target, previousState, messageWhenEnabled);
  }

  togglePasswordVisibility(event) {
    event.preventDefault();

    const button = event.currentTarget;
    const input = document.getElementById(button.dataset.passwordTargetId);
    if (!input) return;

    const showing = input.type === 'text';
    input.type = showing ? 'password' : 'text';
    button.setAttribute('aria-pressed', showing ? 'false' : 'true');
    button.textContent = showing ? 'Show password' : 'Hide password';
  }

  syncPasswordToggle(field, buttonId) {
    const button = document.getElementById(buttonId);
    if (!button) return;

    const hasValue = field.value.length > 0;
    button.classList.toggle('d-none', !hasValue);

    if (!hasValue) {
      field.type = 'password';
      button.setAttribute('aria-pressed', 'false');
      button.textContent = 'Show password';
      return;
    }

    if (field.type === 'text') {
      button.setAttribute('aria-pressed', 'true');
      button.textContent = 'Hide password';
    } else {
      button.setAttribute('aria-pressed', 'false');
      button.textContent = 'Show password';
    }
  }

  toggleNewUserFields(visible) {
    $('[data-new-user-field="1"]').each(function() {
      $(this).closest('.form-group').toggle(visible);
      toggleAssociatedCopy(this, visible);
    });
  }

  updateTerms(event) {
    let termsTarget = this.termsTarget;
    let submitTarget = this.submitTarget;

    if (termsTarget.checked) {
      submitTarget.disabled = false;
      this.announceStatus('Terms accepted. Submit Registration is now available.');
    } else {
      submitTarget.disabled = true;
    }
  }

  updatePhone(event) {
    let phoneTarget = this.phoneTarget;
    let termsTarget = this.termsTarget;

    if (validate_phone(phoneTarget.value)) {
      clearFieldMessage(phoneTarget);
      this.setDisabled(termsTarget, false, 'Phone number accepted. Terms and conditions are now available.');
    } else {
      if (phoneTarget.value.length > 0) {
        setFieldMessage(phoneTarget, 'Please enter a valid 10 digit phone number.');
      } else {
        clearFieldMessage(phoneTarget);
      }
      termsTarget.disabled = true;
    }
  }

  updateConfirmEmail(event) {
    let emailTarget = this.emailTarget;
    let confirmEmailTarget = this.confirmEmailTarget;
    let phoneTarget = this.phoneTarget;

    if (validate_email(emailTarget.value) && emailTarget.value == confirmEmailTarget.value) {
      clearFieldMessage(confirmEmailTarget);
      this.setDisabled(phoneTarget, false, 'Email addresses match. Phone number entry is now available.');
    } else {
      if (confirmEmailTarget.value.length > 0) {
        setFieldMessage(confirmEmailTarget, 'Emails do not match.');
      } else {
        clearFieldMessage(confirmEmailTarget);
      }
      phoneTarget.disabled = true;
    }
  }

  updateEmail(event) {
    let emailTarget = this.emailTarget;
    let confirmEmailTarget = this.confirmEmailTarget;

    let locked = $(emailTarget).data('locked') == '1';

    if (validate_email(emailTarget.value) && !locked) {
      clearFieldMessage(emailTarget);
      this.setDisabled(confirmEmailTarget, false, 'Email accepted. Confirm email is now available.');
    } else {
      confirmEmailTarget.disabled = true;
      if (emailTarget.value.length > 0 && !validate_email(emailTarget.value)) {
        setFieldMessage(emailTarget, 'Enter a valid email address.');
      } else {
        clearFieldMessage(emailTarget);
      }
    }
  }

  updateLastName(event) {
    let lastNameTarget = this.lastNameTarget;
    let emailTarget = this.emailTarget;

    if (lastNameTarget.value.length >= 1) {
      this.setDisabled(emailTarget, false, 'Last name entered. Email address is now available.');
    } else {
      emailTarget.disabled = true;
    }
  }

  updateFirstName(event) {
    let firstNameTarget = this.firstNameTarget;
    let lastNameTarget = this.lastNameTarget;

    if (firstNameTarget.value.length >= 1) {
      this.setDisabled(lastNameTarget, false, 'First name entered. Last name is now available.');
    } else {
      lastNameTarget.disabled = true;
    }
  }

  updateConfirmPassword(event) {
    let passwordTarget = this.passwordTarget;
    let confirmPasswordTarget = this.confirmPasswordTarget;
    let firstNameTarget = this.firstNameTarget;

    this.syncPasswordToggle(confirmPasswordTarget, 'confirm-password-visibility-toggle');

    if (passwordTarget.value.length >= 8 && passwordTarget.value == confirmPasswordTarget.value) {
      clearFieldMessage(confirmPasswordTarget);
      this.setDisabled(firstNameTarget, false, 'Passwords match. First name is now available.');
    } else {
      if (confirmPasswordTarget.value.length > 0) {
        setFieldMessage(confirmPasswordTarget, 'Passwords do not match.');
      } else {
        clearFieldMessage(confirmPasswordTarget);
      }
      firstNameTarget.disabled = true;
    }
  }

  updatePassword(event) {
    let passwordTarget = this.passwordTarget;
    let confirmPasswordTarget = this.confirmPasswordTarget;

    this.syncPasswordToggle(passwordTarget, 'password-visibility-toggle');

    if (passwordTarget.value.length >= 8) {
      clearFieldMessage(passwordTarget);
      this.setDisabled(confirmPasswordTarget, false, 'Password accepted. Confirm password is now available.');
    } else {
      if (passwordTarget.value.length > 0) {
        setFieldMessage(passwordTarget, 'Create a password with at least 8 characters.');
      } else {
        clearFieldMessage(passwordTarget);
      }
      confirmPasswordTarget.disabled = true;
    }
  }

  updateUsername(event) {
    let usernameTarget = this.usernameTarget;
    let passwordTarget = this.passwordTarget;

    if (usernameTarget.value.length >= 5) {
      clearFieldMessage(usernameTarget);
      this.setDisabled(passwordTarget, false, 'Username accepted. Password entry is now available.');
    } else {
      if (usernameTarget.value.length > 0) {
        setFieldMessage(usernameTarget, 'Choose a username with at least 5 lowercase letters or numbers.');
      } else {
        clearFieldMessage(usernameTarget);
      }
      passwordTarget.disabled = true;
    }
  }

  updateEmailCode(event) {
    let emailCodeTarget = this.emailCodeTarget;
    let phoneTarget = this.phoneTarget;

    if (emailCodeTarget.value.length == 10) {
      clearFieldMessage(emailCodeTarget);
      this.setDisabled(phoneTarget, false, 'Verification code accepted. Phone number entry is now available.');
    }
    else {
      if (emailCodeTarget.value.length > 0) {
        setFieldMessage(emailCodeTarget, 'Enter the 10 character verification code from your email.');
      } else {
        clearFieldMessage(emailCodeTarget);
      }
      phoneTarget.disabled = true;
    }
  }

  sendCode(event) {
    event.preventDefault();

    let emailTarget = this.emailTarget;
    let usernameTarget = this.usernameTarget;
    let sendCodeResultTarget = this.sendCodeResultTarget;
    let emailCodeTarget = this.emailCodeTarget;

    if (validate_email(emailTarget.value)) {
      let data = new FormData();
      data.append('username', usernameTarget.value);
      data.append('email', emailTarget.value);

      Rails.ajax({
        url: '/email_verification_codes/send_code',
        type: "POST",
        data: data,
        success: (data) => {
          if (data.success) {
            sendCodeResultTarget.innerHTML = "Verification code has been sent to the email address associated with your account";
            clearFieldMessage(emailTarget);
            this.setDisabled(emailCodeTarget, false, 'Verification code field is now available. Enter the code from your email to continue.');
            this.announceStatus('Verification code sent. Enter the code from your email to continue.');
          } else {
            sendCodeResultTarget.innerHTML = "This email address is not associated with your account. Please contact support at <a href=\"mailto:support@connect4education.com\">support@connect4education.com</a>";
            setFieldMessage(emailTarget, 'This email address is not associated with your account. Please contact support if you need help.');
            emailCodeTarget.disabled = true
            this.announceStatus('Verification code could not be sent because the email address is not associated with an account.');
          }
        }
      })
    } else {
      setFieldMessage(emailTarget, 'Enter a valid email address before requesting a verification code.');
    }
  }

  checkEmail(event) {
    let usernameTarget = this.usernameTarget;
    let emailTarget = this.emailTarget;
    let confirmEmailTarget = this.confirmEmailTarget;

    let existingUser = $(usernameTarget).data('existing-user');

    if (!existingUser && validate_email(emailTarget.value)) {
      let data = new FormData();
      data.append('field', 'email');
      data.append('value', emailTarget.value);

      Rails.ajax({
        url: '/api/check_moodle_field',
        type: "POST",
        data: data,
        success: (data) => {
          if (data.exists) {
            setFieldMessage(emailTarget, 'This email is already associated with an account under a different username.')
            confirmEmailTarget.disabled = true;
          } else {
            clearFieldMessage(emailTarget)
            this.setDisabled(confirmEmailTarget, false, 'Email accepted. Confirm email is now available.');
          }
        }
      })
    } else {
      confirmEmailTarget.disabled = true;
    }
  }

  checkUsername(event) {
    let usernameTarget = this.usernameTarget;
    let emailTarget = this.emailTarget;
    let verificationContainerTarget = this.verificationContainerTarget;

    let data = new FormData();
    data.append('field', 'username');
    data.append('value', usernameTarget.value);

    Rails.ajax({
      url: '/api/check_moodle_field',
      type: "POST",
      data: data,
      success: (data) => {
        if (data.exists) {
          let errorMessage = "Username already exists. Please choose a different username or enter your email address below to verify your account.";
          setFieldMessage(usernameTarget, errorMessage, { invalid: false, level: 'info' });
          verificationContainerTarget.hidden = false;
          this.setDisabled(emailTarget, false, 'Existing account detected. Email verification is now available.');
          this.announceStatus('Existing account detected. Enter your email address and request a verification code.');
          $(usernameTarget).data('existing-user', true);
          this.toggleNewUserFields(false);
        } else {
          clearFieldMessage(usernameTarget);
          verificationContainerTarget.hidden = true;
          emailTarget.disabled = true;
          $(usernameTarget).data('existing-user', false);
          this.toggleNewUserFields(true);
        }
      }
    })
  }

  updateAccessCode(event) {
    let accessCodeTarget = this.accessCodeTarget;
    if (accessCodeTarget.value.length < 3) {
      return;
    }
    let courseTarget = this.courseTarget;
    let usernameTarget = this.usernameTarget;

    let data = new FormData();
    data.append('access_code', accessCodeTarget.value);
    data.append('course_request_id', courseTarget.value);

    Rails.ajax({
      url: '/access_codes/verify',
      type: "POST",
      data: data,
      success: (data) => {
        if (!data.valid) {
          if (data.access_code_error) {
            setFieldMessage(accessCodeTarget, data.access_code_error);
            usernameTarget.disabled = true;
          }
        } else {
          clearFieldMessage(accessCodeTarget);
          this.setDisabled(usernameTarget, false, 'Access code accepted. Username entry is now available.');
        }
      }
    })
  }

  updateSchool(event) {
    let school = this.schoolTarget.value;
    let instructor = this.instructorTarget;
    instructor.value = null;

    this.clearSemester()
    this.clearCourse()
    this.clearInstructor()

    let instructors = select_data.filter(function(el){ return el[3][1] == school })
    var opt = document.createElement('option');
    opt.value = '';
    opt.innerHTML = "Select Instructor...";
    instructor.appendChild(opt);
    instructors.forEach(function(el){
      if (skipObjectIfExists(instructor, el[1][1])) return;
      var opt = document.createElement('option');
      opt.value = el[1][1];
      opt.innerHTML = el[1][0];
      instructor.appendChild(opt);
    })

    this.setDisabled(instructor, !school, 'Instructor selection is now available.');
  }


  updateInstructor(event) {
    let semester = this.semesterTarget;
    let instructor = this.instructorTarget.value;
    let school = this.schoolTarget.value;

    this.clearSemester()
    this.clearCourse()


    let semesters = select_data.filter(function(el){ return el[3][1] == school && el[1][1] == instructor })
    var opt = document.createElement('option');
    opt.value = '';
    opt.innerHTML = "Select Semester...";
    semester.appendChild(opt);
    semesters.forEach(function(el){
      if (skipObjectIfExists(semester, el[2][1])) return;
      var opt = document.createElement('option');
      opt.value = el[2][1];
      opt.innerHTML = el[2][0];
      semester.appendChild(opt);
    })

    this.setDisabled(semester, !instructor, 'Semester selection is now available.');
  }

  updateSemester(event) {
    let course = this.courseTarget;
    let semester = this.semesterTarget.value;
    let instructor = this.instructorTarget.value;
    let school = this.schoolTarget.value;

    this.clearCourse()

    let courses = select_data.filter(function(el){ return el[3][1] == school && el[1][1] == instructor && el[2][1] == semester  })
    var opt = document.createElement('option');
    opt.value = '';
    opt.innerHTML = "Select Course...";
    course.appendChild(opt);
    courses.forEach(function(el){
      var opt = document.createElement('option');
      opt.value = el[0][1];
      opt.innerHTML = el[0][0];
      course.appendChild(opt);
    })

    this.setDisabled(course, !semester, 'Course selection is now available.');

  }

  updateCourse(event){
    let course = this.courseTarget.value;
    let accessCodeTarget = this.accessCodeTarget;
    let course_value = select_data.filter(function(el){ return el[0][1] == course })[0];

    if (!course_value) {
      accessCodeTarget.disabled = true;
      $('.registration-date-message').hide();
      $('.registration-details').show();
      return;
    }

    let start_date = new Date(course_value[0][3].replace(/\-/g,'\/').replace(/[T|Z]/g,' '));
    let end_date = new Date(course_value[0][4].replace(/\-/g,'\/').replace(/[T|Z]/g,' '));
    let course_end_date = new Date(course_value[0][5].replace(/\-/g,'\/').replace(/[T|Z]/g,' '));
    let current_date = new Date();
    let isSuccess = true;
    let errorMessage = ''

    if (start_date != null && current_date < start_date) {
      isSuccess = false;
      errorMessage = 'The registration period for this course has not started yet. The registration period runs:' + getDateInterval(start_date, end_date) + '. Should you require further assistance, please contact your instructor';
    } else if (end_date != null && current_date > end_date) {
      isSuccess = false;
      errorMessage = 'The registration period for this course has ended. The registration period runs:' + getDateInterval(start_date, end_date) + '. Should you require further assistance, please contact your instructor.';
    } else if (start_date != null && end_date != null && course_end_date && course_end_date < current_date) {
      isSuccess = false;
      errorMessage = 'This course has ended. Should you require further assistance, please contact Connect4Education Technical Support at 703-880-1180 x200 or <a href="mailto:support@connect4education.com">support@connect4education.com</a>';
    }

    if (isSuccess) {
      if (course_value[0][2] == 'no_lti' || course_value[0][2] == ''){
        $('.lti-course-message').hide();
        $('.registration-details').show();
        this.setDisabled(accessCodeTarget, false, 'Course selected. Enter the course access code to unlock the registration form.');
      }
      else {
        $('.lti-course-message').show();
        $('.registration-details').hide();
        this.announceStatus('Registration is not required for this course. Proceed to your learning management system for access.');
      }
      $('.registration-date-message').hide();
    } else {
      $('.registration-date-message').html(errorMessage);
      $('.registration-date-message').show();
      $('.registration-details').hide();
      this.announceStatus($(this.element).find('.registration-date-message').text());
    }
  }

  clearInstructor(){
    let school = this.schoolTarget.value;
    let instructor = this.instructorTarget;
    instructor.value = '';
    instructor.disabled = true;
    instructor.innerHTML = '';
    return true;
  }

  clearSemester(){
    let instructor = this.instructorTarget;
    let semester = this.semesterTarget;
    semester.value = null;
    semester.disabled = true;
    semester.innerHTML = '';
  }

  disableRemainingFields() {
    $('.registration-details input').attr('disabled', 'disabled');
  }

  clearCourse(){
    let semester = this.semesterTarget;
    let course = this.courseTarget;
    course.value = null;
    course.disabled = true;
    course.innerHTML = '';
    this.disableRemainingFields();
  }
}
